import { SPICINESS_LEVEL, WORKING_PATHWAYS } from '../../constants';
import { HotPepper } from '../../components';
import s from './styles.scss';

const Label = () => {};

const Mild = () => (
  <div className={s.label}>
    <HotPepper /> {SPICINESS_LEVEL[1]} selected
  </div>
);

const Medium = () => (
  <div className={s.label}>
    <HotPepper />
    <HotPepper />
    {SPICINESS_LEVEL[2]} selected
  </div>
);

const Spicy = () => (
  <div className={s.label}>
    <HotPepper />
    <HotPepper />
    <HotPepper />
    {SPICINESS_LEVEL[3]} selected
  </div>
);

const MildPath = () => (
  <div className={s.label}>
    <HotPepper /> {WORKING_PATHWAYS[1]} selected
  </div>
);

const MediumPath = () => (
  <div className={s.label}>
    <HotPepper />
    <HotPepper />
    {WORKING_PATHWAYS[2]} selected
  </div>
);

const SpicyPath = () => (
  <div className={s.label}>
    <HotPepper />
    <HotPepper />
    <HotPepper />
    {WORKING_PATHWAYS[3]} selected
  </div>
);

Label.Mild = Mild;
Label.Medium = Medium;
Label.Spicy = Spicy;
Label.MildPath = MildPath;
Label.MediumPath = MediumPath;
Label.SpicyPath = SpicyPath;

export { Label };
